const getters = {
  isLogin: state => state.isLogin,
  TEFn: state => state.TEFn,
  IMFn: state => state.IMFn,
  membersFn: state => state.membersFn,
  tabDataFn: state => state.tabDataFn,
  tabQuesFn: state => state.tabQuesFn,
  userInfo: state => state.userInfo,
  TRTCFn: state => state.TRTCFn,
  roomInfo: state => state.roomInfo,
  videoUserList: state => state.videoUserList,
  questionnaireList: state => state.questionnaireList,
  informationList: state => state.informationList,
  locaLayoutConfig: state => state.locaLayoutConfig,
  meetingLayoutConfigList: state => state.meetingLayoutConfigList,
  meetingSenceConfigList: state => state.meetingSenceConfigList,
  IMStatus: state => state.IMStatus,
  TRTCStatus: state => state.TRTCStatus,
  IM: state => state.IM,
  isShareScreen: state => state.isShareScreen,

  meetingConfig: state => state.meetingConfig,
  meetingInfo: state => state.meetingInfo,
  conferee: state => state.conferee,
  confereeCurrentStatus: state => state.confereeCurrentStatus,
  meetingCurrentStatus: state => state.meetingCurrentStatus,
  sdkAppId: state => state.sdkAppId,
  mcuMixTranscodeimgUrl: state => state.mcuMixTranscodeUrl,
  tipsFlag:state => state.tipsFlag,
  surveyCodeList:state => state.surveyCodeList,
  screenShareStream: state => state.screenShareStream,
  allowGenerator: state => state.allowGenerator
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js